/**
 * PlayEditorPage - Block-based play editor
 *
 * Uses the block system with UndoProvider for state management.
 */

import { useParams } from 'react-router-dom'
import { UndoProvider } from '@/hooks/usePlayBlocks/undo'
import { SaveStatusProvider } from '@/contexts/SaveStatusContext'
import { PlayEditorBlockContent } from './PlayEditorBlockContent'
import { Loading } from '@/components/ui/Loading'
import './play-editor-page.css'

/**
 * Block-based Play Editor Page
 * Uses the block system with UndoProvider.
 */
export function PlayEditorPage() {
	const { playbookId, playId } = useParams<{
		playbookId?: string
		playId?: string
	}>()

	// Validate required params
	if (!playbookId || !playId) {
		return <Loading text="Missing playbook or play ID" />
	}

	return (
		<UndoProvider>
			<SaveStatusProvider>
				<PlayEditorBlockContent
					playbookId={playbookId}
					playBlockId={playId}
				/>
			</SaveStatusProvider>
		</UndoProvider>
	)
}
